import { Styles } from "jspdf-autotable";

export const getFonts = () => {
  const normalFontSize = 10;
  const bigFontSize = 12;

  const normalFontStyles: Partial<Styles> = {
    fontSize: normalFontSize,
    font: "NotoSans",
    fontStyle: "bold"
  };
  const bigFontStyles: Partial<Styles> = {
    fontSize: bigFontSize,
    font: "NotoSans",
    fontStyle: "bold"
  };

  return {
    normalFontSize,
    normalFontStyles,
    bigFontSize,
    bigFontStyles
  };
};
